import { Tags as Tags$2 } from './Tags.style.js';
import { jsx } from 'react/jsx-runtime';
import useIsGlobetrotter from '../../../hooks/useIsGlobetrotter.js';
import Tag from '../../Tag/Tag.js';

var Tags = function Tags(_ref) {
  var tags = _ref.tags;
  var isGlobetrotter = useIsGlobetrotter();
  if (isGlobetrotter) {
    return /*#__PURE__*/jsx(Tags$2, {
      children: tags.map(function (tag) {
        return /*#__PURE__*/jsx("li", {
          className: "uikit-font-mini",
          children: tag
        }, tag);
      })
    });
  }
  return /*#__PURE__*/jsx(Tags$2, {
    as: "div",
    children: tags.map(function (tag) {
      return /*#__PURE__*/jsx(Tag, {
        small: true,
        children: tag
      }, tag);
    })
  });
};
var Tags$1 = Tags;

export { Tags$1 as default };
//# sourceMappingURL=Tags.js.map
